export var EmissorContractStatus;
(function (EmissorContractStatus) {
    EmissorContractStatus["REQUESTED"] = "REQUESTED";
    EmissorContractStatus["CREATED"] = "CREATED";
    EmissorContractStatus["ACTIVATED"] = "ACTIVATED";
    EmissorContractStatus["CANCELED"] = "CANCELED";
})(EmissorContractStatus || (EmissorContractStatus = {}));
